import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { referenceLogos } from '../mock';

export const References = ({ language, translations }) => {
  const t = translations[language];

  return (
    <div className="min-h-screen pt-24 pb-20">
      <div className="container mx-auto px-4">
        <Link to="/">
          <Button variant="outline" className="mb-8">
            <ArrowLeft className="mr-2 w-4 h-4" />
            {t.nav.home}
          </Button>
        </Link>

        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">{t.references.title}</h1>
          <p className="text-xl text-gray-600 mb-2">{t.references.subtitle}</p>
          <p className="text-lg text-gray-500">{t.references.description}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {referenceLogos.map((reference, index) => (
            <div 
              key={index}
              className="bg-white border-2 border-gray-200 rounded-lg p-8 flex items-center justify-center hover:border-blue-500 hover:shadow-xl transition-all duration-300 h-40 group"
            >
              <img 
                src={reference.url} 
                alt={reference.name} 
                className="max-h-20 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
